



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Unit, UnitsApi } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import SecondaryButton from '@/components/Buttons/SecondaryButton/index.vue';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    SecondaryButton,
  },
})
export default class AccountActivation extends Vue {
  @Prop()
  public emailUser!: string;

  @Prop()
  public loading!: boolean;

  public onSave() {
    this.$emit('submit');
  }

  get adminUser() {
    if (UserModule.currentRole !== 'partner_owner') {
      return UserModule.currentRole;
    }
    return null;
  }
}
